import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createExtensionListQueryOptions, getExtensionsFromGQLResult } from '../web-client';
export function getForgeUIExtensionsAsync(_x) {
  return _getForgeUIExtensionsAsync.apply(this, arguments);
}
function _getForgeUIExtensionsAsync() {
  _getForgeUIExtensionsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var client, contextIds, moduleType, queryOptions, expandAppOwner, extensionsFilter, dataClassificationTagIds, requestOptions, queryResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          client = _ref.client, contextIds = _ref.contextIds, moduleType = _ref.moduleType, queryOptions = _ref.queryOptions, expandAppOwner = _ref.expandAppOwner, extensionsFilter = _ref.extensionsFilter, dataClassificationTagIds = _ref.dataClassificationTagIds;
          requestOptions = createExtensionListQueryOptions(client, contextIds, queryOptions, expandAppOwner, extensionsFilter, moduleType, dataClassificationTagIds);
          _context.next = 4;
          return client.query(requestOptions);
        case 4:
          queryResult = _context.sent;
          return _context.abrupt("return", {
            extensions: getExtensionsFromGQLResult(queryResult),
            errors: queryResult.errors
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getForgeUIExtensionsAsync.apply(this, arguments);
}